import { Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap'

function Search({
  placeholder,
  value,
  setValue,
  width = 'w-75',
  marginBottom = 'mb-4',
}) {
  return (
    <InputGroup className={`${width} ${marginBottom}`}>
      <Input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        type='text'
        bsSize='sm'
        style={{
          padding: '18px',
        }}
      />
      <InputGroupAddon addonType='append'>
        <InputGroupText style={{ backgroundColor: '#01A0F2' }}>
          <button
            style={{
              fontSize: '15px',
              height: '10px',
            }}
            className='border-0 bg-transparent d-flex  justify-content-center align-items-center'
          >
            <i class='fas fa-search search-icon'></i>
          </button>
        </InputGroupText>
      </InputGroupAddon>
    </InputGroup>
  )
}

export default Search
